import { Map } from 'immutable';
import { SET_LOGGED_IN, SET_LOGGED_OUT, START_AUTHENTICATION } from './constants';

export const initialState = Map({
	isLoggedIn: false,
	isAuthenticating: false,
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LOGGED_IN:
			return state.merge({
				isLoggedIn: true,
				isAuthenticating: false,
			});
		case SET_LOGGED_OUT:
			return state.merge({
				isLoggedIn: false,
				isAuthenticating: false,
			});
		case START_AUTHENTICATION:
			return state.merge({
				isAuthenticating: true,
			});
		default:
			return state;
	}
};

export default reducer;
